import React from "react";
import OrganizerDetail from "../../../../components/sections/front/OrganizerDetail";

export default function OrganizerDetails() {
  return <OrganizerDetail />;
}
